import {
  AssignmentTurnedInRounded,
  CloudUploadRounded,
  EmailRounded,
  ExploreRounded,
  HomeWorkRounded,
  MarkunreadMailboxRounded,
  MyLocationRounded,
  Phone,
  RoomRounded,
  TodayRounded,
  TranslateRounded,
  VpnKey
} from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { ChangeEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { enableDisableMenu, verifyUser } from '../../../../../../../redux/actions/users'
import { IRootState } from '../../../../../../../redux/types'
import UserItemMobile from '../../../../../../shared/components/UserItemMobile'
import ModalInfo from '../../../../../../shared/components/modals/ModalInfo'
import { isAdmin, isClient, isCommercial, isManager, isNotClientAndTrainer } from '../../../../utils/RolesHelper'
import { MenusUserInfo } from './MenusUserInfo'
import { VerificationUserInfo } from './VerificationUserInfo'

interface MobileUserInfoProps {
  openChangePassword: boolean
  setOpenChangePassword: (value: boolean) => void
  user_id: number | string | null
}

export function MobileUserInfo({ openChangePassword, setOpenChangePassword, user_id }: MobileUserInfoProps) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected } = useSelector((state: IRootState) => state.user)

  const [verification, setVerification] = useState(userProfileSelected.verification)

  const handleCheckChange = (event: any) => {
    const verificationId: number = Number.parseInt(event.target.value)
    setVerification(verificationId)
    dispatch(verifyUser({ user_id, verificationId }))
  }

  const handleClickAccessMenu = (menu_id: number) => (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(
      enableDisableMenu({
        user_id: userProfileSelected.id,
        menu_id,
        status: event.target.checked
      })
    )
  }

  useEffect(() => {
    if (userProfileSelected !== null) setVerification(userProfileSelected.verification)
  }, [userProfileSelected])

  return (
    <Grid container justifyContent="space-between" alignItems="flex-start" spacing={2}>
      <Grid xs={12} md={6} lg={4}>
        <Typography variant="body1" style={{ fontWeight: 700 }}>
          {t('personal-info')}
        </Typography>
        <UserItemMobile label={t('email')} content={userProfileSelected.email} icon={<EmailRounded />} />
        <UserItemMobile label={t('phone')} content={userProfileSelected.phone} icon={<Phone />} />
        {isCommercial(userProfileSelected.role_id) && (
          <UserItemMobile
            label={t('admin.people.code')}
            content={userProfileSelected.commercial_code}
            icon={<AssignmentTurnedInRounded />}
          />
        )}
        <UserItemMobile
          label={t('language')}
          content={userProfileSelected.languages
            .map((language: any) => {
              return language.name
            })
            .join(', ')}
          icon={<TranslateRounded />}
        />
        {isNotClientAndTrainer(authUser.role_id) && authUser.role.code < userProfileSelected.roleCode && (
          <Box
            typeof="button"
            display="flex"
            alignItems="center"
            style={{ color: '#3483FA', fontWeight: 500 }}
            p={'14px'}
            gap={14}
            onClick={() => {
              setOpenChangePassword(!openChangePassword)
            }}
          >
            <VpnKey />
            <Typography variant="body2">{t('login.change-password')}</Typography>
          </Box>
        )}
      </Grid>
      <Grid xs={12} md={6} lg={4}>
        <Typography variant="body1" style={{ fontWeight: 700 }}>
          {isClient(userProfileSelected.role_id) ? <>{t('center-data')}</> : <>{t('address-data')}</>}
        </Typography>
        <UserItemMobile label={t('country')} content={userProfileSelected.countryName} icon={<ExploreRounded />} />
        <UserItemMobile label={t('province')} content={userProfileSelected.provinceName} icon={<RoomRounded />} />
        <UserItemMobile label={t('town')} content={userProfileSelected.townName} icon={<HomeWorkRounded />} />
        <UserItemMobile label={t('address')} content={userProfileSelected.address} icon={<MyLocationRounded />} />
        <UserItemMobile label={t('postal-code')} content={userProfileSelected.postalcode} icon={<MarkunreadMailboxRounded />} />
      </Grid>
      <Grid xs={12} md={6} lg={4}>
        <Box pb={3}>
          <Typography color="textSecondary" variant="subtitle1">
            {t('admin.people.accesses-and-records')}
          </Typography>
        </Box>
        {isManager(authUser.role_id) && <MenusUserInfo handleClickAccessMenu={handleClickAccessMenu} />}
        {(isAdmin(authUser.role_id) || authUser.can_verify === 1) && (
          <VerificationUserInfo verification={verification} handleCheckChange={handleCheckChange} />
        )}
        <Box pb={1}>
          <ModalInfo title={t('admin.people.manage-countries')} options={userProfileSelected.countries} />
        </Box>
        <UserItemMobile label={t('admin.people.created-date')} content={userProfileSelected.created_date} icon={<TodayRounded />} />

        <UserItemMobile
          label={t('admin.people.rec-from')}
          content={userProfileSelected.rec_from === null ? 'unknown' : userProfileSelected.rec_from}
          icon={<CloudUploadRounded />}
        />
      </Grid>
    </Grid>
  )
}
